import { OpsResultsTable } from './Data'
import React, { Component, useContext, useState } from 'react'
import {
  Accordion,
  AccordionPanel,
  Box,
  Tabs,
  Heading,
  Tab,
  List,
  Main,
  Paragraph,
  Text,
  Tip,
  Video
} from 'grommet'
import withOpsApi from './withOpsApi'
import { PageCard } from './Cards'
import { FormDown, FormSubtract, FormUp } from 'grommet-icons'
import { MotionBox } from './Motion'
import { LoadingHeader } from './Common'
import moment from 'moment'
import { AppContext } from '../libs/context'
import { labelByMode } from '../libs/common'
const tabSpeaker = (speaker) => {
  return speaker !== 'A'
}
const SPEAKERS = {
  A: { color: 'dark-1', background: 'white', width: '90%' },
  B: { color: 'dark-2', background: 'light-1', width: '88%' },
  C: { color: 'dark-3', background: 'light-3', width: '86%' },
  D: { color: 'dark-4', background: 'light-4', width: '84%' },
  E: { color: 'dark-1', background: 'light-5', width: '81%' },
  F: { color: 'dark-1', background: 'light-3', width: '83%' },
  G: { color: 'dark-1', background: 'light-2', width: '75%' },
  UNK: { color: 'mesh-accent-red', background: 'white', width: '90%' }
}
const SENTIMENT_MAP = {
  1: { name: 'positive', color: 'dark-2', Icon: FormUp },
  '-1': { name: 'negative', color: 'mesh-accent-red', Icon: FormDown },
  0: { name: 'neutral', color: 'dark-6', Icon: FormSubtract }
}
const SENTIMENT_COLOR = {
  POSITIVE: 'dark-2',
  NEGATIVE: 'mesh-accent-red',
  NEUTRAL: 'dark-6'
}
const getSentimentIcon = (score) => {
  const Icon = SENTIMENT_MAP[score].Icon
  return <Icon color={SENTIMENT_MAP[score].color} />
}
export const TranscriptsTable = (props) => {
  const { demoMode } = useContext(AppContext)
  return (
    <OpsResultsTable
      {...props}
      apiPath={'product/calls/transcripts'}
      heading={labelByMode('transcripts', demoMode)}
      apiFilters={[
        {
          label: 'Search',
          field: 'search',
          placeholder: 'caller, number, or gist'
        },
        {
          label: 'Call greater than (s)',
          field: 'tw_call_length__gte',
          placeholder: 'sec'
        },
        {
          label: 'Sentiment Score',
          field: 'sentiment_score',
          optionProps: { valueKey: 'id', labelKey: 'name' },
          options: [
            {
              id: 0,
              name: 'Neutral'
            },
            {
              id: '-1',
              name: 'Negative'
            }
          ],
          defaultValue: 0,
          placeholder: 'select'
        }
      ]}
      renderResultWith={{
        ResultComponent: Transcript
        // recordType: 'receiver',
        // apiParams: { expand: ['store_set'] }
      }}
      showColumns={[
        {
          property: 'id',
          header: <Text weight={'bold'}>id</Text>,
          primary: true
        },
        {
          property: 'created_at',
          header: <Text weight={'bold'}>Date</Text>,
          render: ({ created_at }) => <Text>{moment(new Date(created_at)).format('lll')}</Text>
        },
        {
          property: 'tw_caller_name',
          header: <Text weight={'bold'}>caller</Text>
        },
        {
          property: 'tw_to_number',
          header: <Text weight={'bold'}>to</Text>
        },
        {
          property: 'tw_from_number',
          header: <Text weight={'bold'}>from</Text>
        },
        {
          property: 'tw_call_length',
          header: <Text weight={'bold'}>length (s)</Text>
        },
        {
          property: 'aai_headline',
          header: <Text weight={'bold'}>headline</Text>,
          render: ({ aai_headline, aai_summary }) => (
            <Tip content={<Paragraph size={'small'}>{aai_headline}</Paragraph>}>
              <Box
                round="small"
                background="light-1"
                pad={{ horizontal: 'small' }}
                justify="center"
                width="medium"
                flex={false}
                height={'xxsmall'}
              >
                <Text truncate>{aai_headline}</Text>
              </Box>
            </Tip>
          )
        },
        {
          property: 'sentiment_score',
          header: <Text weight={'bold'}>sentiment</Text>,
          render: ({ sentiment_score, sentiment_data }) => (
            <Tip content={sentiment_score}>{getSentimentIcon(sentiment_score)}</Tip>
          )
        }
        // {
        //   property: 'aai_summary',
        //   // header: <Text weight={'bold'}>sentiment</Text>,
        //   render: ({ aai_summary }) => (
        //
        //         <Chat />
        //       </Box>
        //     </Tip>
        //   )
        // }
      ]}
    />
  )
}
const UtterBox = ({ utter }) => (
  <Box
    elevation={'small'}
    background={SPEAKERS[utter.speaker].background}
    round="small"
    flex={false}
    pad={'medium'}
    gap={'xsmall'}
    // width={'medium-medium'}
    width={SPEAKERS[utter.speaker].width}
  >
    <Heading level={5} color={SPEAKERS[utter.speaker].color} margin={'none'}>
      SPEAKER {utter.speaker}
    </Heading>
    {utter.sentiment && (
      <Box
        round
        width={'80px'}
        flex={false}
        align={'center'}
        background={SENTIMENT_COLOR[utter.sentiment]}
        pad={{ horizontal: 'small', vertical: 'xxsmall' }}
      >
        <Text size={'xsmall'} weight={'bold'}>
          {utter.sentiment}
        </Text>
      </Box>
    )}
    <Paragraph size={'xxlarge'} fill>
      {utter.text}
    </Paragraph>
  </Box>
)
const _Transcript = ({ fromApi: { apiLoading, result = {} }, closeAction }) => {
  // This will not dismount stacks from the Dom Tree. We can use one stack HOC and pass chilldren
  const stacks = {
    empty: 0
  }
  const setStack = (stack, value = undefined) => {
    console.log(stack)
    setSelected({ stack: stack, ...(value && { value: value }) })
  }
  const {
    transcript_from_aai = {},
    tw_caller_name,
    tw_from_number,
    tw_to_number,
    tw_call_direction,
    tw_call_length,
    sentiment_score,
    sentiment_data
  } = result
  const {
    chapters = [],
    utterances = [],
    entities = [],
    iab_categories_result = { summary: {} },
    auto_highlights_result = { results: [] },
    sentiment_analysis_results = [],
    audio_url,
    status
  } = transcript_from_aai
  const chapter = chapters.length > 0 ? chapters[0] : {}
  const [selected, setSelected] = useState({ stack: 0 })
  const [accIndex, setAccIndex] = useState(0)

  const motionStackProps = {
    initial: { opacity: 1, x: 500 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 1, x: 500 },
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 0.6,
      staggerChildren: 0.07,
      delayChildren: 0.2
    }
  }

  const resetStack = () => {
    setSelected({ stack: 0 })
  }
  const commonStackProps = {
    width: { min: 'medium', max: 'xlarge' },
    fill: 'vertical',
    border: { side: 'top', color: 'light-4' },
    elevation: 'xlarge',
    background: 'white',
    closeAction: resetStack
  }

  const commonButtonProps = {
    color: 'light-5',
    primary: true,
    plain: false,
    fill: 'horizontal'
  }
  return (
    <MotionBox
      // flex={'grow'}
      fill
      border={{ side: 'top', color: 'light-4' }}
      elevation={'xlarge'}
      background="light-2"
      variants={{
        open: { opacity: 1, y: 0 },
        collapsed: { opacity: 1, y: '110vh' }
      }}
      initial="collapsed"
      animate="open"
      exit="collapsed"
      transition={{
        type: 'spring',
        bounce: 0.1,
        duration: 0.6,
        staggerChildren: 0.07,
        delayChildren: 0.2
      }}
    >
      <LoadingHeader loading={apiLoading} />

      <PageCard show={!apiLoading} heading={chapter.gist} closeAction={closeAction}>
        <Box direction={'row'} gap={'small'} pad={'small'}>
          <Main width={'medium-medium'} pad={'medium'}>
            <Box background="dark-6" height={'xxsmall'}>
              <Video controls="over" fit="contain">
                <source
                  key="audio"
                  src={audio_url}
                  // type="audio/mpeg"
                />
              </Video>
            </Box>
            <Accordion activeIndex={accIndex} onActive={setAccIndex}>
              <AccordionPanel label="Call details">
                <Box flex={false} fill="horizontal" gap={'small'} pad={'small'}>
                  <Text color="dark-6" level={2} weight={'bold'} size={'large'}>
                    {chapter.headline}
                  </Text>
                  <Paragraph color={'dark-4'} fill>
                    {chapter.summary}
                  </Paragraph>

                  <List
                    pad={'small'}
                    data={[
                      { name: 'From', value: tw_from_number },
                      { name: 'To', value: tw_to_number },
                      { name: 'Call direction', value: tw_call_direction },
                      { name: 'Call length (min)', value: tw_call_length },
                      { name: 'Caller Name', value: tw_caller_name },
                      { name: 'Transcription', value: status }
                    ]}
                    primaryKey={(item) => (
                      <Text color="dark-6" size="medium">
                        {item.name}
                      </Text>
                    )}
                    secondaryKey={(item) => (
                      <Text size="medium" weight="bold" color={'dark-4'}>
                        {item.value}
                      </Text>
                    )}
                  />
                </Box>
              </AccordionPanel>
              <AccordionPanel label={'Sentiment = ' + SENTIMENT_MAP[sentiment_data.overall].name}>
                <Box pad="large" fill="horizontal" align="center" direction="row" gap={'medium'}>
                  {Object.keys(SENTIMENT_COLOR).map((key) => (
                    <Box
                      align={'center'}
                      pad={'medium'}
                      gap={'small'}
                      key={key}
                      round={'small'}
                      background={'white'}
                      elevation={'small'}
                      width={'33%'}
                      height={'xsmall'}
                    >
                      <Text size={'small'} weight={'bold'} color={'dark-6'}>
                        {key}
                      </Text>
                      <Text size={'large'} weight={'bold'} color={SENTIMENT_COLOR[key]}>
                        {Math.round(sentiment_data.percentage[key] * 100)}{' '}
                        <Text size={'xxsmall'}>%</Text>
                      </Text>
                    </Box>
                  ))}
                </Box>
              </AccordionPanel>
              <AccordionPanel label="Auto Highlights">
                <List
                  pad={'small'}
                  data={auto_highlights_result.results}
                  primaryKey={(item) => (
                    <Text truncate size="medium">
                      {item.text} x {item.count}
                    </Text>
                  )}
                  secondaryKey={(item) => (
                    <Text size="medium" weight="bold">
                      {item.rank}
                    </Text>
                  )}
                />
              </AccordionPanel>
              <AccordionPanel label="Entities">
                <List
                  pad={'small'}
                  data={entities}
                  primaryKey={(item) => (
                    <Text truncate size="medium" weight="bold">
                      {item.entity_type}
                    </Text>
                  )}
                  secondaryKey={(item) => <Text size="medium">{item.text}</Text>}
                />
              </AccordionPanel>
              <AccordionPanel label="Categories">
                <List
                  pad={'small'}
                  data={Object.keys(iab_categories_result.summary).map((k) => {
                    return { name: k, score: iab_categories_result.summary[k] }
                  })}
                  primaryKey={(item) => (
                    <Text truncate size="medium" weight="bold">
                      {item.name.replace('>', ', ')}
                    </Text>
                  )}
                  secondaryKey={(item) => <Text size="medium">{item.score}</Text>}
                />
              </AccordionPanel>
            </Accordion>
          </Main>
          <Box
            round={'small'}
            pad={'medium'}
            gap={'small'}
            // background={'white'}
            fill={'horizontal'}
          >
            <Tabs>
              <Tab title="Full transcript">
                <Main pad={'medium'} gap={'small'} align={'center'}>
                  {utterances.map((utter, index) => (
                    <UtterBox key={index} utter={utter} />
                  ))}
                </Main>
              </Tab>
              <Tab title="sentiment by sentence">
                <Main pad={'medium'} gap={'small'} align={'center'}>
                  {sentiment_analysis_results.map((utter, index) => (
                    <UtterBox key={index} utter={utter} />
                  ))}
                </Main>
              </Tab>
            </Tabs>
          </Box>
        </Box>
      </PageCard>
    </MotionBox>
  )
}
export const Transcript = withOpsApi(_Transcript)
